import ExpedientesProduccionIndex from "../components/reportes/ExpedientesProduccion/ExpedientesProduccionIndex";

export default ExpedientesProduccionIndex;
